<iq-central-front-end-navbar></iq-central-front-end-navbar>
<section class="container my-5 d-body">
  <div>
    <div class="my-3 d-flex justify-content-between">
      <div class="font20">Courses</div>
      <div *rbacAllow="[true]">
        <button
          class="btn btn-secondary btn-sm"
          routerLink="/courses/create-course"
        >
          Create Course
        </button>
      </div>
    </div>

    <div class="d-flex align-items-center sm-reverse table-search-container">
      <div
        class="text-green font12 font-bold col-lg-2 col-md-2 col-sm-12 sm-text-center sm-mt sm-mb-2"
      >
        ADD FILTER
      </div>
      <div class="table-search col-lg-7 col-md-7 col-sm-12">
        <input
          type="text"
          placeholder="Search"
          #query
          (keyup)="filter(query.value)"
        />
      </div>
      <div
        class="sort col-lg-3 col-md-3 col-sm-12 sm-mt sm-mb-2 sm-text-center"
      >
        <span class="font-bold font12 text-grey mr-3">SORT BY</span>
        <span class="dropdown click">
          <span
            class="font-bold text-green font12 dropdown-toggle"
            id="dropdownMenuButton"
            data-toggle="dropdown"
          >
            <i class="fa fa-chevron-down"></i
          ></span>
          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <a class="dropdown-item click line-under" (click)="sortByName()"
              >Name</a
            >
            <a class="dropdown-item click" (click)="sortByDate()">Date</a>
            <a class="dropdown-item click">State</a>
          </div>
        </span>
      </div>
    </div>
    <div *rbacAllow="[true]">
      <p
        class="font20 text-green py-3 text-center mt-2"
        *ngIf="
          courses.length === 0 &&
          (isOnline$ | async) === true &&
          fetchCoursesFailed === false
        "
      >
        There are no courses yet you can create one by clicking on the create
        course button on the top right corner
      </p>
    </div>
    <div *rbacAllow="[false]">
      <p
        class="font20 text-green py-3 text-center mt-2"
        *ngIf="
          courses.length === 0 &&
          (isOnline$ | async) === true &&
          fetchCoursesFailed === false
        "
      >
        There are no courses yet
      </p>
    </div>
    <div class="sections__wrapper my-3">
      <div class="row mt-3 section-content">
        <ng-container *ngIf="isFetchingCourses">
          <div
            class="col-12 col-md-6 col-lg-3 mt-4"
            *ngFor="let item of [1, 2, 3, 4, 5, 6, 7, 8]"
          >
            <div class="course-card">
              <div class="thumbnail">
                <ngx-skeleton-loader
                  [animation]="'progress-dark'"
                  [theme]="{
                    height: '160px',
                    'border-radius': '4px 4px 0 0',
                    'margin-bottom': '12px',
                    'background-color': '#EAEAEA'
                  }"
                ></ngx-skeleton-loader>
              </div>

              <div class="course-title">
                <ngx-skeleton-loader
                  [animation]="'progress-dark'"
                  [theme]="{
                    height: '24px',
                    'margin-bottom': '8px',
                    'background-color': '#EAEAEA'
                  }"
                ></ngx-skeleton-loader>
              </div>

              <div class="instructor">
                <ngx-skeleton-loader
                  [animation]="'progress-dark'"
                  [theme]="{
                    height: '16px',
                    width: '70%',
                    'margin-bottom': '8px',
                    'background-color': '#EAEAEA'
                  }"
                ></ngx-skeleton-loader>
              </div>

              <div class="rating">
                <ngx-skeleton-loader
                  [animation]="'progress-dark'"
                  [theme]="{
                    height: '16px',
                    width: '50%',
                    'margin-bottom': '8px',
                    'background-color': '#EAEAEA'
                  }"
                ></ngx-skeleton-loader>
              </div>

              <div class="price">
                <ngx-skeleton-loader
                  [animation]="'progress-dark'"
                  [theme]="{
                    height: '20px',
                    width: '40%',
                    'margin-bottom': '4px',
                    'background-color': '#EAEAEA'
                  }"
                ></ngx-skeleton-loader>
              </div>
            </div>
          </div>
        </ng-container>
        <div
          class="col-12 col-md-6 col-lg-3 mt-4"
          *ngFor="let course of courses; index as i"
        >
          <div
            class="course"
            [ngClass]="{ 'inactive-course': course.isActive === false }"
          >
            <div class="bg-white">
              <div
                class="p-r"
                [routerLink]="['/courses/course-details', course['code']]"
              >
                <img
                  src="{{ course?.imageUrl }}"
                  alt=""
                  class="w-100 courseImg"
                />
                <span class="course-duration p-1">{{
                  transformDuration(i)
                }}</span>
              </div>
              <div class="p-4">
                <div class="d-flex">
                  <span>
                    {{ course?.title }}
                  </span>
                  <input
                    type="checkbox"
                    (change)="selectDeselectCourses($event, course)"
                    id="checkbox{{ i }}"
                    class="checkbox"
                    hidden
                  />
                  <label class="ml-auto" for="checkbox{{ i }}">
                    <span
                      class="save font30 click"
                      [class]="course.isSaved ? 'like' : 'dislike'"
                      >❤</span
                    >
                  </label>
                </div>
                <div class="img-rating-header d-flex justify-content-between">
                  <div class="font12">
                    <h5 class="mb-0 mt-2 text-grey font12 font-medium">
                      LEVEL
                    </h5>
                    <div>
                      {{ course?.level }}
                    </div>
                  </div>
                  <div class="name-rating">
                    <h5 class="mb-0 mt-2 text-grey font12 font-medium">
                      RATING
                    </h5>
                    <div class="rating {{ rating(course) }}  font14">
                      <span>☆</span><span>☆</span><span>☆</span><span>☆</span
                      ><span>☆</span>
                    </div>
                  </div>
                </div>

                <span *ngIf="course.isActive === false" class="inactive-badge"
                  >Inactive</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-container *ngIf="fetchCoursesFailed">
    <app-retry
      (tryAgain)="getResolvedData()"
      message="Failed to load courses"
    ></app-retry>
  </ng-container>

  <div class="mt-auto">
    <hr />
    <iq-central-front-end-footer></iq-central-front-end-footer>
  </div>
</section>
